module.exports = __webpack_public_path__ + "img/text_only_icon.b9d15b3c.svg";